import { axiosInstance as axios } from "services";

export const addManufactureOrSubType = async (body) => {
  // Create a minimal material entry to register the manufacturer/subType
  const { data } = await axios.post("/pricing/master/material", body);
  if (!data.success) throw new Error(data.error || "Failed to add manufacture or sub type");
  return data;
};

